import { FC } from 'react';

import { useTaxOfficesQuery } from '@/api/getters';
import Profit from '@/assets/profit.svg?react';
import ComboBox from '@/components/ui/ComboBox';
import ErrorMessage from '@/components/ui/ErrorMessage';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';
import { validateTaxOffice } from '@/features/v2/summaryForms/Validate';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

// Endpoint zwraca ~850 urzędów, a każda etykieta zawiera frazę "Urząd
// Skarbowy" - samo wpisanie "urz" pasuje do całej listy. Wirtualizacja
// zdejmuje koszt renderowania, próg odcina bezużyteczną listę wszystkiego.
const MIN_QUERY_LENGTH = 3;

interface Props {
  name: string;
  focused: string;
  setFocused: (value: string) => void;
}

const TaxOfficeField: FC<Props> = ({ name, focused, setFocused }) => {
  const { i18n } = useLingui();
  const { trigger } = useFormContext();
  const { data: taxOfficesData = [] } = useTaxOfficesQuery();

  return (
    <div className="flex flex-col gap-3">
      <p className="h5 col-span-2 flex items-center gap-2">
        <Profit className="size-4 text-blue-600" />
        {i18n.t('Urząd Skarbowy')}
      </p>
      <FormField
        defaultValue={''}
        name={name}
        rules={{
          validate: (value: string) => validateTaxOffice(value),
        }}
        render={({ field, fieldState }) => {
          const { value, onChange, onBlur } = field;
          return (
            <FormItem>
              <FormControl>
                <ComboBox
                  withSearchOnMobile
                  virtualized
                  minQueryLength={MIN_QUERY_LENGTH}
                  value={field.value === null ? '' : value}
                  placeholder={'Wybierz Urząd Skarbowy'}
                  error={fieldState.error?.message}
                  options={taxOfficesData}
                  success={
                    focused !== field.name && !fieldState.error && field.value
                  }
                  onChange={(e) => {
                    onChange(e);
                    trigger(field.name);
                    setFocused('');
                  }}
                  onBlur={() => {
                    setFocused('');
                    onBlur();
                  }}
                  onFocus={() => {
                    setFocused(field.name);
                  }}
                  field={field}
                />
              </FormControl>
              {fieldState.error && !field.value && (
                <ErrorMessage errorMessage={fieldState.error?.message} />
              )}
            </FormItem>
          );
        }}
      />
    </div>
  );
};

export default TaxOfficeField;
